import postHttp from './../../plugin/extendFn/postHttp'
import loginService from './../../plugin/extendFn/loginService'
import AppSetting from '../../AppSetting';


async function KeepAliveGard(to, from, next) {
    console.log("gard >>> KeepAliveGard ----------------------------------------");
    let vxuser = await loginService.getLoginUser();
    let query = to.query
    
    if (from.name == 'Details') {
      if (sessionStorage.getItem('ilnmtime') <= 0) {
        next();
      } else {
        if (vxuser) {
          if (vxuser.uPhone) {
            if (query.type == 'video') {
              let params = {
                vid: query.videoId,
                uid: vxuser ? vxuser.uId : 0,
                time: sessionStorage.getItem('ilnmtime') * 1,
              }
              console.log('参数', params)
              axios.post(AppSetting.baseUrl + '/video/info/exit', params).then((res) => {
                console.log(res);
  
                if (res.data.code == 0) {
                  next();
  
                }
              })
            } else {
              next()
            }
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  
    if (to.name == 'Video') {
      if (from.name == 'Details' || from.name == 'vDetails') {
        to.meta.keepAliveChange = false
      } else {
        to.meta.keepAliveChange = true
      }
    }
  
    next();
}

export default KeepAliveGard


// WEBPACK FOOTER //
// ./src/router/gard/KeepAliveGard.js